import { Loading } from 'notiflix'
import { Confirm } from 'notiflix/build/notiflix-confirm-aio'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { colors, font } from '../tokens'

let initialised = false

/**
 * Applies the design tokens to every Notiflix dialog. Call once at app start
 * (`App.tsx`); after this, pages should not pass colour options to
 * `Report.*` / `Confirm.*` / `Loading.*` calls.
 *
 * Destructive confirms can still opt into the danger palette with
 * `notiflixDanger` (spread into the options argument).
 */
export const initNotiflixTheme = (): void => {
    if (initialised) return
    initialised = true

    Report.init({
        fontFamily: font,
        backgroundColor: colors.surface,
        borderRadius: '10px',
        backOverlayColor: 'rgba(15, 23, 34, 0.45)',
        titleFontSize: '16px',
        messageFontSize: '13px',
        buttonFontSize: '13px',
        svgSize: '72px',
        cssAnimationStyle: 'zoom',
        cssAnimationDuration: 220,
        success: {
            svgColor: colors.good,
            titleColor: colors.ink,
            messageColor: colors.ink2,
            buttonBackground: colors.accent,
            buttonColor: colors.inkInverse,
            backOverlayColor: 'rgba(15, 23, 34, 0.45)',
        },
        failure: {
            svgColor: colors.bad,
            titleColor: colors.ink,
            messageColor: colors.ink2,
            buttonBackground: colors.bad,
            buttonColor: colors.inkInverse,
            backOverlayColor: 'rgba(15, 23, 34, 0.45)',
        },
        warning: {
            svgColor: colors.warn,
            titleColor: colors.ink,
            messageColor: colors.ink2,
            buttonBackground: colors.accent,
            buttonColor: colors.inkInverse,
            backOverlayColor: 'rgba(15, 23, 34, 0.45)',
        },
        info: {
            svgColor: colors.accent,
            titleColor: colors.ink,
            messageColor: colors.ink2,
            buttonBackground: colors.accent,
            buttonColor: colors.inkInverse,
            backOverlayColor: 'rgba(15, 23, 34, 0.45)',
        },
    })

    Confirm.init({
        fontFamily: font,
        width: '360px',
        backgroundColor: colors.surface,
        borderRadius: '10px',
        backOverlayColor: 'rgba(15, 23, 34, 0.45)',
        titleColor: colors.ink,
        titleFontSize: '16px',
        messageColor: colors.ink2,
        messageFontSize: '13px',
        buttonsFontSize: '13px',
        okButtonBackground: colors.accent,
        okButtonColor: colors.inkInverse,
        cancelButtonBackground: colors.surface3,
        cancelButtonColor: colors.ink2,
        cssAnimationStyle: 'zoom',
        cssAnimationDuration: 220,
    })

    Loading.init({
        fontFamily: font,
        backgroundColor: 'rgba(15, 23, 34, 0.55)',
        svgColor: colors.accentTint,
        messageColor: colors.inkInverse,
        messageFontSize: '13px',
        svgSize: '64px',
    })
}

/** Spread into `Confirm.show(..., notiflixDanger)` for destructive actions. */
export const notiflixDanger = {
    titleColor: colors.bad,
    okButtonBackground: colors.bad,
    okButtonColor: colors.inkInverse,
} as const
